/**
 * @generated SignedSource<<f7308d4d877e9831bb1693e94c15a220>>
 * @relayHash 8ebe27a4a0e3823db7f7f952813cb599
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e48bb4b7afbc87afd515357b3edf322880f144b2fde25999c70f8f761facd28c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LegacyRecommendedAgentResultsQuery$variables = {
  agentsPerSource?: number | null;
  cloudIdString: string;
  first?: number | null;
  hasOotb1: boolean;
  hasOotb2: boolean;
  hasOotb3: boolean;
  hasRecentAgents: boolean;
  ids: ReadonlyArray<string>;
  ootb1: string;
  ootb2: string;
  ootb3: string;
  product?: string | null;
  templateProduct?: string | null;
};
export type LegacyRecommendedAgentResultsQuery$data = {
  readonly agentStudio_getAllTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly previewRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateView_StudioBrowseKit">;
        };
        readonly templateRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateCard_StudioBrowseKit">;
        };
      } | null;
    } | null> | null;
  } | null;
  readonly ootb1?: {
    readonly agentRef?: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
    readonly deactivated?: boolean | null;
    readonly id?: string;
  } | null;
  readonly ootb2?: {
    readonly agentRef?: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
    readonly deactivated?: boolean | null;
    readonly id?: string;
  } | null;
  readonly ootb3?: {
    readonly agentRef?: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
    readonly deactivated?: boolean | null;
    readonly id?: string;
  } | null;
  readonly recentAgents?: ReadonlyArray<{
    readonly agentRef?: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
    } | null;
    readonly id?: string;
  } | null> | null;
  readonly verifiedAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly agentRef: {
          readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
        };
        readonly id: string;
      } | null;
    }>;
  } | null;
};
export type LegacyRecommendedAgentResultsQuery = {
  response: LegacyRecommendedAgentResultsQuery$data;
  variables: LegacyRecommendedAgentResultsQuery$variables;
};
({
  "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isUpliftEnabled_provider from '@atlassian/studio-browse-kit/ui/agent-card/components/isAgentAuthorUpliftEnabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentsPerSource"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasOotb1"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasOotb2"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasOotb3"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasRecentAgents"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ids"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ootb1"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ootb2"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ootb3"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateProduct"
},
v13 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudIdString"
},
v14 = [
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "externalReference",
    "variableName": "ootb1"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "ScalarField",
  "name": "deactivated"
},
v17 = {
  "fragment": {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "AgentCardRelay_StudioBrowseKit"
      }
    ],
    "type": "AgentStudioAssistant"
  },
  "kind": "AliasedInlineFragmentSpread",
  "name": "agentRef"
},
v18 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "type": "AgentStudioAssistant"
  }
],
v19 = [
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "externalReference",
    "variableName": "ootb2"
  }
],
v20 = [
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "externalReference",
    "variableName": "ootb3"
  }
],
v21 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v22 = [
  (v15/*: any*/),
  (v17/*: any*/)
],
v23 = [
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "agentsPerSource"
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyVerifiedAgents": true
    }
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "product"
  }
],
v24 = [
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "templateProduct"
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "name"
},
v26 = {
  "kind": "ScalarField",
  "name": "description"
},
v27 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v28 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v29 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "icon"
},
v31 = {
  "kind": "ScalarField",
  "name": "externalConfigReference"
},
v32 = {
  "kind": "ScalarField",
  "name": "identityAccountId"
},
v33 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v34 = {
  "kind": "ScalarField",
  "name": "picture"
},
v35 = {
  "kind": "LinkedField",
  "name": "identityAccount",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isUser"
    },
    (v34/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appType"
        }
      ],
      "type": "AppUser"
    },
    (v15/*: any*/)
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "creatorType"
},
v37 = {
  "kind": "ScalarField",
  "name": "forgeCreator"
},
v38 = {
  "concreteType": "TeamV2",
  "kind": "LinkedField",
  "name": "authoringTeam",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    (v15/*: any*/)
  ]
},
v39 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v25/*: any*/),
    {
      "kind": "ScalarField",
      "name": "accountStatus"
    },
    {
      "condition": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v34/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        }
      ]
    },
    (v15/*: any*/)
  ]
},
v40 = [
  (v33/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v15/*: any*/),
      (v16/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/)
    ],
    "type": "AgentStudioAssistant"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v15/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "LegacyRecommendedAgentResultsQuery",
    "selections": [
      {
        "condition": "hasOotb1",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "ootb1",
            "args": (v14/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_getByExternalReference",
            "plural": false,
            "selections": (v18/*: any*/)
          }
        ]
      },
      {
        "condition": "hasOotb2",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "ootb2",
            "args": (v19/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_getByExternalReference",
            "plural": false,
            "selections": (v18/*: any*/)
          }
        ]
      },
      {
        "condition": "hasOotb3",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "ootb3",
            "args": (v20/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_getByExternalReference",
            "plural": false,
            "selections": (v18/*: any*/)
          }
        ]
      },
      {
        "condition": "hasRecentAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "recentAgents",
            "args": (v21/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentsByIds",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v22/*: any*/),
                "type": "AgentStudioAssistant"
              }
            ]
          }
        ]
      },
      {
        "alias": "verifiedAgents",
        "args": (v23/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v22/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "args": (v24/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateCard_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "templateRef"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateView_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "previewRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "LegacyRecommendedAgentResultsQuery",
    "selections": [
      {
        "alias": "verifiedAgents",
        "args": (v23/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v24/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v33/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "avatarUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "usageCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "templateAppKeys"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "tags"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "executionTier"
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateSupportedTrigger",
                    "kind": "LinkedField",
                    "name": "supportedTriggers",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v25/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateHowItWorksStep",
                    "kind": "LinkedField",
                    "name": "howItWorks",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "role"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "text"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "hasOotb1",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "ootb1",
            "args": (v14/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_getByExternalReference",
            "plural": false,
            "selections": (v40/*: any*/)
          }
        ]
      },
      {
        "condition": "hasOotb2",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "ootb2",
            "args": (v19/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_getByExternalReference",
            "plural": false,
            "selections": (v40/*: any*/)
          }
        ]
      },
      {
        "condition": "hasOotb3",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "ootb3",
            "args": (v20/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_getByExternalReference",
            "plural": false,
            "selections": (v40/*: any*/)
          }
        ]
      },
      {
        "condition": "hasRecentAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "recentAgents",
            "args": (v21/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentsByIds",
            "plural": true,
            "selections": [
              (v33/*: any*/),
              (v15/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v29/*: any*/)
                ],
                "type": "AgentStudioAssistant"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e48bb4b7afbc87afd515357b3edf322880f144b2fde25999c70f8f761facd28c",
    "metadata": {},
    "name": "LegacyRecommendedAgentResultsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
    }
  }
};
})();

(node as any).hash = "462e0a2035ec33a1410855d9c341caea";

export default node;
